/**
 * Enum representing the steps in the Provet dialog/booking flow.
 * @property ImportantInformation - Step for displaying important information.
 * @property SelectClinic - Step for selecting a clinic.
 * @property SelectTreatment - Step for selecting a treatment.
 * @property SelectDateAndTime - Step for selecting date and time.
 * @property ContactDetails - Step for entering contact details.
 * @property Confirmation - Step for confirming the booking.
 * @property Confirmed - Step for confirmed booking.
 */
export enum ProvetDialogStep {
  ImportantInformation = 0,
  SelectClinic = 1,
  SelectTreatment = 2,
  SelectDateAndTime = 3,
  ContactDetails = 4,
  Confirmation = 5,
  Confirmed = 6
}

export function isProvetDialogStep(
  value: string
): value is keyof typeof ProvetDialogStep {
  return Object.keys(ProvetDialogStep)
    .filter(k => isNaN(Number(k)))
    .includes(value);
}
